import { render, staticRenderFns } from "./UpdatePriceForm.vue?vue&type=template&id=e4318428&scoped=true&"
import script from "./UpdatePriceForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePriceForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePriceForm.vue?vue&type=style&index=0&id=e4318428&prod&scoped=true&lang=css&"
import style1 from "./UpdatePriceForm.vue?vue&type=style&index=1&id=e4318428&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4318428",
  null
  
)

export default component.exports